module.exports = __webpack_public_path__ + "img/Save.6aca99ff.svg";